{
  "en": {
    "posts": {
      "index": {
        "title": "News from fobizz",
        "empty": "There are currently no news for this language.",
        "error": "The news could not be loaded. Please try again later.",
        "pinnedAria": "Pinned Post",
        "publishedAt": "Published on {date}"
      }
    }
  }
}
